import mutations from './doctor.mutations'
import actions from './doctor.actions'
import getters from './doctor.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
